module.exports = __webpack_public_path__ + "static/img/15-1.c9a3951.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/15-1.jpg
// module id = y+oy
// module chunks = 0